import Ajax from './base'

const LandingPage = {
  getSemaLandingPage: (payload = {}) => {
    const { programType, ...queryParams } = payload
    if (!programType) {
      throw new Error('programType is required')
    }
    const queryString =
      Object.keys(queryParams).length > 0
        ? `?${new URLSearchParams(queryParams).toString()}`
        : ''

    const route = `/v8/landing_page/${programType}${queryString}`

    return Ajax.request(route, {})
  },
}

export default LandingPage
